// [원본 복원] 전개발자 구조 유지. 얹은 것: ①지문분석 선택 색 ②모바일 사이즈 ③넘침 차단
const VocaMatchingCard = ({ selectedIndex, word, handleClick, type }) => {
  const m = Math.min(window.innerWidth, window.screen.width) <= 768;
  const isSelected = selectedIndex === word.index;
  const isMatched = word.isMatched;
  return (
    <div
      key={word.text}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // 데스크톱은 컨테이너 기준(위 VocaStudyCard 와 같은 이유)
        width: m ? "16vw" : "calc(20% - 8px)",
        minWidth: 0,
        minWidth: m ? "56px" : undefined,
        height: m ? "70px" : "25vh",
        // [수정] overflow:hidden은 원본에 없던 것 — 좁은 칸에서 단어의
        // 양끝 글자를 깎았다("carelessly"→"relessly"). 원본대로 자연 줄바꿈에 맡긴다.
        border: "1px solid #EBEBEB",
        boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        padding: m ? "4px" : "10px",
        boxSizing: "border-box",
        fontSize: m ? "11px" : "20px",
        backgroundColor:
          (isSelected || isMatched) &&
          (type === "analysis" ? "#E5FBF8" : "#EBEBEB"), // ①지문분석만 ECHO
        transition: "background-color 0.5s ease",
        textAlign: "center",
      }}
      onClick={() => {
        if (isMatched) return;
        handleClick(word.index);
      }}
    >
      <div
        style={{
          // 긴 뜻이 카드 밖으로 삐져나와 잘려 보여서(2026-08-23) 카드 안 스크롤을 달았는데,
          // **아이폰 카카오톡 브라우저에서 스크롤 칸을 누르면 스크롤로 받아들여 카드가
          // 안 눌렸다**(2026-09-28 라이트하우스 박주안, 오류 신고 #31). 짧은 영어 카드만
          // 눌리고 긴 뜻 카드는 아무리 눌러도 짝이 안 맞았다.
          // 그래서 스크롤을 없애고, 긴 뜻은 글자를 줄여 세 줄 안에 담는다. 긴 뜻을
          // 읽을 수 있게 하려던 8/23 의 목적은 작은 글자로 지킨다. 누르는 것은 항상
          // 바깥 카드가 받도록 안쪽은 터치를 받지 않는다.
          pointerEvents: "none",
          fontSize: String(word.text).length > 12 ? (m ? "10px" : "16px") : undefined,
          lineHeight: 1.25,
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        {word.text}
      </div>
    </div>
  );
};

export default VocaMatchingCard;
